<template>
  <van-popup v-model:show="data.show" round>
    <div class="container">
      <div class="pay_popup">
        <p>{{ $t('reader.subscribe_success') }}</p>
        <p>{{ $t('reader.read_all_novels') }}</p>
        <div class="got_it_btn" @click="closePopup">{{ $t('reader.i_got_it') }}</div>
        <img class="icon_w" src="~/assets/images/reader/icon-reader-w.png" alt="">
        <img class="icon_l" src="~/assets/images/reader/icon-reader-light.png" alt="">
        <img class="icon_c" src="~/assets/images/reader/icon-reader-popup-close.png" alt="" @click="closePopup">
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive} from 'vue'

const route = useRoute()
import {useUserInfo} from '~/composables/useUserInfo'
import eventBus from "../../utils/eventBus";
import {useCommonStore} from '../../stores/common'
const commonStore = useCommonStore()
const {getUserInfo} = useUserInfo()
const data = reactive({
  show: false
})

const open = async () => {
  //   获取到同一订单的order_no
  const orderNo = localStorage.getItem('order_no')
  if (!orderNo) {
    // 如果没有，说明从来没弹过，直接弹出弹窗
    data.show = true
  } else {
    if (orderNo === route.query.order_no) return false
    data.show = true
  }
  localStorage.setItem('order_no', route.query.order_no)
  await getUserInfo()
  //   给阅读器发送更新章节列表消息
  console.log('给阅读器发送更新章节列表消息')
}

const closePopup = async() => {
  data.show = false
  // 判断下有没有绑定邮箱
  await commonStore.getBindEmail()
  console.log('绑定邮箱', commonStore.email)
  // 如果没有绑定邮箱，则不去触发updateChapterList方法，而是在邮箱绑定弹窗中去操作
  if (commonStore.email === ''){
    eventBus.emit('showBindEmailPopup')
  } else {
    eventBus.emit('updateChapterList', route.query.chapter_id ? route.query.chapter_id : '')
  }
}

defineExpose({
  open
})
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;

}

.container {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

  .pay_popup {
    //width: 302px;
    height: 203px;
    background: #FF1979;
    background: url('~/assets/images/reader/icon-reader-pay-success.png');
    background-size: 100%;
    background-repeat: round;
    padding: 50px 21px 21px;
    position: relative;

    .icon_w {
      position: absolute;
      left: 50%;
      top: -60px;
      width: 156px;
      transform: translateX(-50%);
    }

    .icon_l {
      position: absolute;
      left: 50%;
      top: -98px;
      width: 281px;
      transform: translateX(-50%);
      z-index: -1;
    }

    .icon_c {
      position: absolute;
      left: 50%;
      top: calc(100% + 21px);
      width: 25px;
      transform: translateX(-50%);
      height: 25px;
    }

    p {
      font-family: 'SFPro', 'SFPro';

      &:first-child {
        font-weight: 600;
        font-size: 19px;
        color: #222222;
        line-height: 22px;
        text-align: center;
        font-style: normal;
      }

      &:nth-child(2) {
        font-weight: 500;
        font-size: 15px;
        color: #FF7749;
        line-height: 18px;
        text-align: center;
        font-style: normal;
        margin-top: 13px;
      }
    }

    .got_it_btn {
      width: 100%;
      height: 47px;
      background: linear-gradient(90deg, #FF394D 0%, #FF398F 100%);
      box-shadow: 0px 2 10px 0px rgba(232, 57, 102, 0.3), inset 0px 3 8px 0px rgba(255, 190, 217, 0.8);
      border-radius: 23px;
      font-family: 'SFPro', 'SFPro';
      font-weight: 600;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 47px;
      text-align: center;
      font-style: normal;
      margin-top: 26px;
    }
  }
}

</style>
